import { useMemo, useRef } from 'react';
import isEqual from 'lodash/isEqual';

const useDeepCompareMemo = <T>(value: T): T => {
  const ref = useRef<T>(value);
  const signalRef = useRef<number>(0);

  if (!isEqual(value, ref.current)) {
    ref.current = value;
    signalRef.current += 1;
  }

  return useMemo(() => ref.current, [signalRef.current]);
};

export default useDeepCompareMemo;
